<template>
  <el-dialog
    custom-class="dialog-wrapper scroll-dialog"
    :title="dialogTitle"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    v-model="dialogVisible"
  >
    <div class="item-title">
      屏蔽总开关 <span class="optional-tip">（选填，可多选）</span>
    </div>
    <el-form :inline="true">
      <el-form-item label="手机系统">
        <el-select
          multiple
          v-model="systemBlock"
          placeholder="可多选，已选不可重复"
          class="campus-select"
        >
          <el-option label="HarmonyOS" value="2"></el-option>
          <el-option label="Android" value="0"></el-option>
          <el-option label="iOS" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div class="item-title">
      版本号屏蔽 <span class="optional-tip">（选填）</span>
    </div>
    <el-form :inline="true">
      <div
        class="margin-bottom-10"
        v-for="(item, index) in versionBlock"
        :key="'ver-' + index"
      >
        <el-form-item label="手机系统">
          <el-select v-model="item.osType">
            <el-option label="HarmonyOS" value="2"></el-option>
            <el-option label="Android" value="0"></el-option>
            <el-option label="iOS" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本号">
          <el-input v-model="item.version" placeholder="不限制"></el-input>
        </el-form-item>
        <el-button v-if="index == 0" type="primary" @click="clickAddVersion"
          >添加</el-button
        >
        <el-button
          v-if="index != 0"
          type="danger"
          icon="delete"
          @click="clickDeleteVersion(index)"
        ></el-button>
      </div>
    </el-form>

    <template #footer>
      <div class="flex-row-center">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="clickEditDone">确定</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogTitle: "",
    dataSource: {},
  },

  data() {
    return {
      dialogVisible: false,
      systemBlock: [], // 多选系统屏蔽，字符串 "0"/"1"/"2"
      versionBlock: [{ osType: "", version: "" }],
    };
  },

  methods: {
    // 发送更新
    sendUpdate() {
      const resValue = {};
      if (this.systemBlock && this.systemBlock.length) {
        resValue["systemBlock"] = this.systemBlock.map(Number); // 数字数组
      }
      const versionValue = this.versionBlock
        .filter(
          (item) =>
            item.osType &&
            item.osType !== "" &&
            item.version &&
            item.version !== ""
        )
        .map((item) => ({ osType: item.osType, version: item.version }));
      if (versionValue.length) {
        resValue["versionBlock"] = versionValue;
      }

      const param = {
        tag: this.dataSource.tag,
        key: this.dataSource.resKey,
        value: JSON.stringify(resValue),
      };

      this.$http({
        url: this.$util.domain + "/adminapi/v1/tools/addOrUpdateConfig",
        method: "POST",
        dataType: "json",
        body: JSON.stringify(param),
      })
        .then((res) => {
          if (res.data.error === 10000) {
            this.dialogVisible = false;
            this.$emit("refresh");
          } else {
            this.$util.errorMsg(res.message);
          }
        })
        .catch((error) => {
          this.$util.errorMsg("保存失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 点击编辑：回填已有数据
    clickEdit() {
      // 先重置，避免缓存
      this.systemBlock = [];
      this.versionBlock = [{ osType: "", version: "" }];

      if (this.dataSource.resValue && this.dataSource.resValue !== "") {
        try {
          const resValue = JSON.parse(this.dataSource.resValue);
          if (resValue.systemBlock && Array.isArray(resValue.systemBlock)) {
            this.systemBlock = resValue.systemBlock.map(String);
          }
          if (resValue.versionBlock && Array.isArray(resValue.versionBlock)) {
            this.versionBlock = resValue.versionBlock.map((item) => ({
              osType: String(item.osType),
              version: item.version || "",
            }));
          }
        } catch (error) {
          console.log("聚推广告-解析数据失败:", error);
        }
      }
      this.dialogVisible = true;
    },

    // 版本号屏蔽：添加
    clickAddVersion() {
      this.versionBlock.push({ osType: "", version: "" });
    },
    // 版本号屏蔽：删除
    clickDeleteVersion(index) {
      this.versionBlock.splice(index, 1);
    },

    // 确认：保存
    clickEditDone() {
      this.sendUpdate();
    },
  },
};
</script>

<style scoped>
.item-title {
  font-size: 16px;
  font-weight: 500;
  margin: 10px 0;
}

.optional-tip {
  font-size: 12px;
  font-weight: 400;
  color: #999;
}

.el-select {
  width: 200px;
}

.el-input {
  width: 200px;
}

.campus-select {
  width: 460px;
}
</style>

<style>
.scroll-dialog > .el-dialog__body {
  max-height: 60vh;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// JuTuiAdShield.vue?1100db75